import { render, staticRenderFns } from "./bottomMobile.vue?vue&type=template&id=3010af1e&scoped=true&"
import script from "./bottomMobile.vue?vue&type=script&lang=js&"
export * from "./bottomMobile.vue?vue&type=script&lang=js&"
import style0 from "./bottomMobile.vue?vue&type=style&index=0&id=3010af1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3010af1e",
  null
  
)

export default component.exports